<template>
    <div class="kgk-team-leave">
        <h3>Team verlassen</h3>
        <p>
            Falls du aus deinem Team austreten möchtest, hast du hier die Möglichkeit dazu.<br>
            Deine Läufe werden automatisch mit in ein neues Team übertragen.<br>
            <i class="fas fa-info-circle"></i> Du kannst eine Einladung von einem anderen Team erst dann erhalten und akzeptieren, wenn du dieses Team verlassen hast.
        </p>
        <button type="button" @click.prevent="leaveButton">
            <i class="fas fa-sign-out-alt"></i>
            <span class="button-text">Team verlassen</span>
        </button>
    </div>
</template>

<script>
    import user from '../../api/user';

    export default {
        name: 'TeamLeave',
        props: {
            teamName: {
                type: String,
                required: true
            }
        },
        data() {
            return {

            }
        },
        computed: {

        },
        methods: {
            leaveButton() {
                const _this = this;

                let fired = false;

                this.$modal.show('dialog', {
                    title: 'Team verlassen',
                    text: `Möchtest du das Team <b>${this.teamName}</b> wirklich verlassen?`,
                    buttons: [
                        {
                            title: 'Abbrechen',
                            default: true,
                        },
                        {
                            title: 'Ja, Team verlassen',
                            handler() {
                                if( fired ) {
                                    return;
                                }

                                fired = true;
                                this.title += ' <i class="fas fa-spinner fa-spin"></i>';
                                _this.leave(
                                    () => _this.$emit('left'),
                                    () => _this.$modal.hide('dialog')
                                );
                            }
                        }
                    ]
                });
            },
            leave(callback, finallyCallback) {
                user.leaveTeam(
                    this,
                    () => {
                        //console.log(data);

                        this.$notify({
                            type: 'success',
                            title: 'Team verlassen',
                            text: `Du hast das Team <b>${this.teamName}</b> erfolgreich verlassen.`
                        });

                        if( callback ) {
                            callback();
                        }
                    },
                    e => {
                        //console.error(e.response.status);
                        if( e.response.status == 400 ) {
                            /*if( typeof e.response.data.field !== 'undefined' ) {
                                // maybe highlight error field
                            }*/

                            this.$notify({
                                type: 'error',
                                title: 'Fehler',
                                text: e.response.data.message
                            });
                            return;
                        }

                        this.$notify({
                            type: 'error',
                            title: 'Es ist ein unbekannter Fehler aufgetreten.',
                            text: 'Bitte versuch es noch einmal.'
                        });
                    },
                    () => {
                        if( finallyCallback ) {
                            finallyCallback();
                        }
                    }
                )
            }
        },
        mounted() {

        }
    }
</script>
